import { render, staticRenderFns } from "./ReportCancellation.vue?vue&type=template&id=710fcb3d&scoped=true&"
import script from "./ReportCancellation.vue?vue&type=script&lang=js&"
export * from "./ReportCancellation.vue?vue&type=script&lang=js&"
import style0 from "./ReportCancellation.vue?vue&type=style&index=0&id=710fcb3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710fcb3d",
  null
  
)

export default component.exports